<div class="layout horizontal middle space-between" >
    <div style="width:calc(100% - 60px)">
        <app-form-field #messageFormField  
            [settings]="settings.fieldsSettings.message" 
            [value]="valuesForInput.message"
            (modelChange)="updateCurrentValue('message',$event)"
            [specifiedAttributes]="specifiedAttributes.message"
            (enterPressure)="!(formSubmitting || !currentValues.message)?submit():null">
        </app-form-field>
    </div>
    <button mat-icon-button (click)="submit()" [disabled]="formSubmitting || !currentValues.message"><mat-icon [ngStyle]="{'color':'#444'}">send</mat-icon></button>
</div>